import { useParams } from 'react-router-dom';
import { TopicInfoCard } from './infoCard';

function TopicContentLeft() {
  const params = useParams();

  return <TopicInfoCard topicID={params.topicId as string} />;
}

export default TopicContentLeft;
